import { useState } from "react";

export function usePsuedoConstructor(callBack = () => { }) {
	const [hasBeenCalled, setHasBeenCalled] = useState(false);
	if (hasBeenCalled) return;
	callBack();
	setHasBeenCalled(true);
}